// Mapeamento das seções do álbum Copa do Mundo.
// Cada custom_section_id da Smartico corresponde a uma seção do dock.
//
// Categoria filtro: `badge.category_ids.includes(96)`.
// Agrupamento: `badge.custom_section_id` → seção.
// Ordem dentro da seção: `badge.position` (asc).

import { getAssetsUrlForCDN } from '@/utils/template';

export type AlbumSection = 'brasil' | 'mundo' | 'lendas' | 'selecao';

export interface AlbumSectionInfo {
  id: AlbumSection;
  customSectionId: number;
  label: string;
  iconType: 'flag' | 'emoji' | 'image';
  iconValue: string;
}

export const ALBUM_SECTIONS: AlbumSectionInfo[] = [
  {
    id: 'brasil',
    customSectionId: 1537,
    label: 'BRASIL',
    iconType: 'image',
    iconValue: getAssetsUrlForCDN(
      '/assets/images/perfil-oficial/copa/brasil.png',
    ),
  },
  {
    id: 'mundo',
    customSectionId: 1538,
    label: 'MUNDO',
    iconType: 'image',
    iconValue: getAssetsUrlForCDN(
      '/assets/images/perfil-oficial/copa/mundo.png',
    ),
  },
  {
    id: 'lendas',
    customSectionId: 1539,
    label: 'LENDAS',
    iconType: 'image',
    iconValue: getAssetsUrlForCDN(
      '/assets/images/perfil-oficial/copa/lendas.png',
    ),
  },
  {
    id: 'selecao',
    customSectionId: 1540,
    label: 'SELEÇÃO',
    iconType: 'image',
    iconValue: getAssetsUrlForCDN(
      '/assets/images/perfil-oficial/copa/selecao.png',
    ),
  },
];

export const ALBUM_CATEGORY_ID = 96;
// 8 colunas × 2 linhas (desktop) / 2 colunas × 2 linhas (mobile).
export const ALBUM_SLOTS_PER_PAGE_DESKTOP = 16;
export const ALBUM_SLOTS_PER_PAGE_MOBILE = 4;

export function getSectionByCustomId(
  customSectionId: number | undefined,
): AlbumSectionInfo | undefined {
  if (customSectionId == null) return undefined;

  return ALBUM_SECTIONS.find((s) => s.customSectionId === customSectionId);
}
